import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import MainFeature1 from "../components/features/TwoColWithButton";
import TeamCardGrid from "../components/cards/ProfileThreeColGrid.js";
import { SectionHeading as HeadingTitle } from "../components/misc/Headings.js";
import { ReactComponent as QuotesLeftIcon } from "../images/quotes-l.svg";
import { ReactComponent as QuotesRightIcon } from "../images/quotes-r.svg";
import { ReactComponent as ArrowLeftIcon } from "../images/arrow-left-2-icon.svg";
import { ReactComponent as ArrowRightIcon } from "../images/arrow-right-2-icon.svg";

import ourmission from "../images/ourmission.webp";
import ourvision from "../images/ourvision.webp";
import ourhistory from "../images/ourhistory.webp";
import companyculture from "../images/ourculture.webp";

import "slick-carousel/slick/slick.css";
import Slider from "react-slick";
import defaultCardImage from "../images/shield-icon.svg";

import ShieldIconImage from "../images/code_35dp_000000_FILL0_wght400_GRAD0_opsz40.svg";
import ShieldIconImage1 from "../images/cloud_35dp_000000_FILL0_wght400_GRAD0_opsz40.svg";
import ShieldIconImage2 from "../images/settings_35dp_000000_FILL0_wght400_GRAD0_opsz40.svg";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-4 lg:py-4`;
const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-0 font-medium text-gray-600 text-center max-w-sm`;

const TestimonialSliderContainer = tw.div`mt-2`;
const TestimonialSlider = styled(Slider)``;
const Testimonial = tw.div`flex! flex-col items-center md:items-stretch md:flex-row md:justify-center outline-none`;
const ImageContainer = styled.div`
  ${tw`md:mx-3 lg:mx-6 w-1/2 md:w-1/4 rounded flex items-center max-w-xs md:max-w-none`}
  img {
    ${tw`rounded w-64 h-64`}
  }
`;
const TextContainer = tw.div`md:mx-3 lg:mx-6 md:w-6/12 py-4 flex flex-col justify-between`;
const QuoteContainer = tw.div`relative p-6 md:p-8 lg:p-10 mt-4 md:mt-0`;
const Quote = tw.blockquote`text-center md:text-left font-medium text-xl lg:text-2xl xl:text-2xl`;
const CustomerInfo = tw.div`px-5 lg:px-10 text-center md:text-left mt-4 md:mt-0`;
const CustomerName = tw.h5`font-bold text-lg lg:text-xl xl:text-2xl text-black`;
const CustomerTitle = tw.p`font-medium text-sm`;

const QuotesLeft = tw(
  QuotesLeftIcon
)`w-8 h-8 lg:w-10 lg:h-10 text-black absolute top-0 left-0`;
const QuotesRight = tw(
  QuotesRightIcon
)`w-8 h-8 lg:w-10 lg:h-10 text-black absolute bottom-0 right-0`;

const SliderControlButtonContainer = styled.div`
  ${tw`absolute top-0 h-full flex items-end md:items-center z-20`}
  button {
    ${tw`text-secondary-500 hover:text-black focus:outline-none transition duration-300 transform hover:scale-125 transform -translate-y-2/3 md:translate-y-0`}
    svg {
      ${tw`w-8`}
    }
  }
`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 px-6 flex`}
`;
const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center  mx-auto py-0 md:py-4`}
`;
const Card = styled.div`
  ${tw`flex flex-col mx-auto max-w-xs items-center px-4 py-8 border-2  border-black border-dashed rounded-lg mt-4`}
  .imageContainer {
    ${tw`border-2 border-black text-center rounded-full p-2 flex-shrink-0 relative`}
    img {
      ${tw`w-6 h-6`}
    }
  }

  .textContainer {
    ${tw`mt-2 text-center`}
  }

  .title {
    ${tw`mt-8 font-bold text-xl leading-none text-black`}
  }

  .description {
    ${tw`mt-3 font-semibold  text-secondary-100 text-sm leading-loose`}
  }
`;

const NextArrow = ({ currentSlide, slideCount, ...props }) => (
  <SliderControlButtonContainer tw="right-0">
    <button {...props}>
      <ArrowRightIcon />
    </button>
  </SliderControlButtonContainer>
);
const PreviousArrow = ({ currentSlide, slideCount, ...props }) => (
  <SliderControlButtonContainer tw="left-0">
    <button {...props}>
      <ArrowLeftIcon />
    </button>
  </SliderControlButtonContainer>
);

export default () => {
  const cards = [
    {
      imageSrc: ShieldIconImage,
      title: "Custom Software Development",
      description:
        "Tailored software solutions to meet your unique business needs.",
    },
    {
      imageSrc: ShieldIconImage1,
      title: "Web Solutions",
      description:
        "Scalable and secure web solutions for enhanced efficiency.",
    },
    {
      imageSrc: ShieldIconImage2,
      title: "IT Consulting",
      description:
        "Expert IT consulting to optimize your technology infrastructure.",
    },
  ];

  const testimonials = [
    {
      imageSrc:
        "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png",
      quote:
        "Aadi Info Solutions transformed our business with their innovative software solutions. Their team is highly skilled and dedicated to delivering exceptional results.",
      customerName: "Subhashish Nayak",
      customerTitle: "Technical Architect. London UK.",
    },
    // {
    //   imageSrc:
    //     "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png",
    //   quote:
    //     "We were impressed with Aadi Info Solutions expertise in cloud solutions.They helped us migrate our infrastructure seamlessly and improved our operational efficiency.",
    //   customerName: "Adam Cuppy",
    //   customerTitle: "Founder, EventsNYC",
    // },
  ];

  return (
    <AnimationRevealPage>
      <HeadingInfoContainer>
        <HeadingTitle tw="text-5xl mt-8 tracking-wide text-center">About Us</HeadingTitle>
        <HeadingDescription></HeadingDescription>
      </HeadingInfoContainer>
      <MainFeature1
        subheading={false}
        heading="Our Mission"
        description="At Aadi Info Solutions, our mission is to empower businesses through innovative software solutions. We strive to deliver exceptional value by understanding our clients' unique challenges and providing tailored technology strategies that drive growth and efficiency. Our commitment is to build long-term partnerships based on trust, transparency, and a shared vision for success."
        buttonRounded={false}
        primaryButtonText={false}
        imageSrc={ourmission}
      />
      <MainFeature1
        subheading={false}
        heading="Our Vision"
        description="Integrity: We uphold the highest ethical standards in all our interactions, ensuring honesty and transparency in our work.
                     Innovation: We embrace creativity and continuous learning to develop cutting-edge solutions that meet evolving business needs.
                     Collaboration: We foster a collaborative environment, both internally and with our clients, to achieve shared goals.
                     Excellence: We are committed to delivering exceptional quality in every project, striving for excellence in all that we do.
                     Client Focus: We prioritize our clients' success, working closely with them to understand their objectives and deliver solutions that exceed expectations."
        buttonRounded={false}
        primaryButtonText={false}
        imageSrc={ourvision}
        textOnLeft={false}
      />

      <MainFeature1
        subheading={false}
        heading="Our History"
        description="Founded in 2025, Aadi Info Solutions began as a small team of dedicated software engineers with a passion for technology. We have grown into a leading provider of custom software development, IT consulting, and digital transformation services. Our journey has been marked by a commitment to innovation, client satisfaction, and a relentless pursuit of excellence. We have successfully partnered with numerous businesses across various industries, helping them leverage technology to achieve their strategic objectives."
        buttonRounded={false}
        primaryButtonText={false}
        imageSrc={ourhistory}
      />

      <MainFeature1
        subheading={false}
        heading="Company Culture"
        description="At Aadi Info Solutions we believe that our people are our greatest asset. We foster a culture of collaboration, innovation, and continuous learning. Our team members are encouraged to share ideas, take initiative, and grow both personally and professionally. We value diversity and inclusivity, creating a supportive environment where everyone can thrive. We also believe in work-life balance and offer flexible work arrangements to ensure our employees can excel both at work and in their personal lives."
        buttonRounded={false}
        primaryButtonText={false}
        imageSrc={companyculture}
        textOnLeft={false}
      />
      <HeadingInfoContainer>
        <HeadingTitle tw="text-4xl pt-12 ">Our Core Services</HeadingTitle>
        <HeadingDescription></HeadingDescription>
      </HeadingInfoContainer>
      <ThreeColumnContainer>
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <img src={card.imageSrc} alt="" />
              </span>
              <span className="textContainer">
                <span className="title">{card.title}</span>
                <p className="description">
                  {card.description}
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <TeamCardGrid subheading={false} />
      <Content>
        <HeadingInfoContainer>
          <HeadingTitle tw="text-4xl ">Our Customer</HeadingTitle>
          <HeadingDescription></HeadingDescription>
        </HeadingInfoContainer>
        <TestimonialSliderContainer>
          <TestimonialSlider
            nextArrow={<NextArrow />}
            prevArrow={<PreviousArrow />}
          >
            {testimonials.map((testimonial, index) => (
              <Testimonial key={index}>
                <ImageContainer>
                  <img
                    src={testimonial.imageSrc}
                    alt={testimonial.customerName}
                  />
                </ImageContainer>
                <TextContainer>
                  <QuoteContainer>
                    <QuotesLeft />
                    <Quote>{testimonial.quote}</Quote>
                    <QuotesRight />
                  </QuoteContainer>
                  <CustomerInfo>
                    <CustomerName>{testimonial.customerName}</CustomerName>
                    <CustomerTitle>{testimonial.customerTitle}</CustomerTitle>
                  </CustomerInfo>
                </TextContainer>
              </Testimonial>
            ))}
          </TestimonialSlider>
        </TestimonialSliderContainer>
      </Content>
    </AnimationRevealPage>
  );
};
